import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import EmployeeForm from '../components/employee/EmployeeForm';
import EmployeeTable from '../components/employee/EmployeeTable';

const EmployeePage = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleEdit = (employee) => {
    setSelectedEmployee(employee);
  };

  const handleFormReset = () => {
    setSelectedEmployee(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'flex-start',
        width: '100%',
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        p: 2,
      }}
    >
      {/* Table - Left Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 2,
          p: 2,
          minWidth: 0,
        }}
      >
        <EmployeeTable onEdit={handleEdit} />
      </Paper>

      {/* Form - Right Side */}
      <Paper
        elevation={3}
        sx={{
          flex: 1,
          p: 2,
          minWidth: 300,
        }}
      >
        <EmployeeForm
          selectedEmployee={selectedEmployee}
          onReset={handleFormReset}
        />
      </Paper>
    </Box>
  );
};

export default EmployeePage;
